import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {
  "title": "Disclaimer Example"
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Disclaimer = makeShortcode("Disclaimer");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Disclaimer mdxType="Disclaimer">
  <h4 id="license-terms"> No trial license key required.</h4>
  The trial of CreativeEditor SDK works without a license key. A commercial license
  key is required for use in a production environment. Get a license key at 
  <a href="https://img.ly/pricing">Pricing</a>
    </Disclaimer>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      